module.exports = __webpack_public_path__ + "img/cpany3.a17f886b.png";